import { render, staticRenderFns } from "./slecteFate.vue?vue&type=template&id=90357186&scoped=true&"
import script from "./slecteFate.vue?vue&type=script&lang=ts&"
export * from "./slecteFate.vue?vue&type=script&lang=ts&"
import style0 from "./slecteFate.vue?vue&type=style&index=0&id=90357186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90357186",
  null
  
)

export default component.exports